import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { getImageUrl } from '../../../utils';
import ContentEditor from '../../ContentEditor';
import NodeActivityEditor from '../../NodeActivityEditor';
import HeaderToolbar from './HeaderToolbar';
import SecondaryButton from '../../SecondaryButton';
import PrimaryButton from '../../PrimaryButton';
import { ViewSection, HeaderUserImage, HeaderUserName, AutoSaveStatus, QuestionWrapper, LockInfo } from '../styles';
import { EditorHeaderRowLeft, EditorHeaderRowRight } from '../../NodeActivityEditor/styles';

const EvaluationContentViewer = ({
  type,
  report,
  data,
  isEditable,
  saveReport,
  user,
  fileService,
  integrations,
  autoSaveStatus,
  isTeacher,
}) => {
  const isLocked = report?.locked;

  const [showToolbar, setShowToolbar] = useState(false);
  const { full_name, image = {}, id } = user || {};
  const headerName = full_name;
  const buttonTextKey = 'app_handin';

  const onChangeReport = (value) => {
    saveReport({ ...report, body: value, draft: true });
  };

  const submitReport = () => {
    saveReport({ ...report, state: 'done', draft: false });
  };

  const revokeReport = () => {
    saveReport({ ...report, state: 'active', draft: true });
  };

  const headerPanel = (
    <>
      <EditorHeaderRowLeft>
        {!isTeacher && <HeaderUserImage key={id} src={getImageUrl(fileService, image, '60x60')} title={full_name} />}
        <HeaderUserName>{isTeacher ? i18n.__('app_student_editor') : headerName}</HeaderUserName>
      </EditorHeaderRowLeft>
      <EditorHeaderRowRight>
        <HeaderToolbar
          isEditable={isEditable}
          report={report}
          isTeacher={isTeacher}
          showToolbar={showToolbar}
          setShowToolbar={setShowToolbar}
        />
      </EditorHeaderRowRight>
    </>
  );

  const editorPanel = (
    <ContentEditor
      type={type}
      value={report?.body || ''}
      onChange={(value) => isEditable && onChangeReport(value)}
      integrations={integrations}
      fileService={fileService}
      disabled={!isEditable}
      showToolbar={showToolbar}
      memoize={true}
    />
  );

  const buttonPanel = !isTeacher && (
    <>
      <AutoSaveStatus>{autoSaveStatus['contentEditor']}</AutoSaveStatus>
      {isLocked ? (
        <LockInfo>{i18n.__('editor_locked_desc')}</LockInfo>
      ) : isEditable ? (
        <SecondaryButton text={i18n.__(buttonTextKey)} onClick={submitReport} disabled={isTeacher} />
      ) : (
        <PrimaryButton text={i18n.__('app_edit')} onClick={revokeReport} disabled={isTeacher} />
      )}
    </>
  );

  return (
    <ViewSection>
      <hr />
      <QuestionWrapper dangerouslySetInnerHTML={{ __html: data.placeholder }} />
      <NodeActivityEditor type={type} headerPanel={headerPanel} editorPanel={editorPanel} buttonPanel={buttonPanel} />
    </ViewSection>
  );
};

export default EvaluationContentViewer;

EvaluationContentViewer.propTypes = {
  type: PropTypes.string.isRequired,
  report: PropTypes.object,
  data: PropTypes.object.isRequired,
  isEditable: PropTypes.bool.isRequired,
  saveReport: PropTypes.func.isRequired,
  user: PropTypes.object,
  fileService: PropTypes.object.isRequired,
  integrations: PropTypes.object.isRequired,
  autoSaveStatus: PropTypes.object.isRequired,
  isTeacher: PropTypes.bool.isRequired,
};
